module.exports = __webpack_public_path__ + "static/Maxine0-82e2011dbd6e9361a6dc11331f60ce89.jpg";